module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/31a6dcded6dfe16288e0104dc10aa605.gif";